import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import WorkflowName from 'automation-ui-references/customer-data/WorkflowName';
import { CLASSIC } from 'automation-ui-flow-core/flow/FlowSourceTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ClassicEnrollInWorkflowActionSummary({
  metadata
}) {
  const {
    workflowId
  } = metadata;
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.classic-enroll-in-flow.summary",
    options: {
      flowName: /*#__PURE__*/_jsx(WorkflowName, {
        flowSourceType: CLASSIC,
        id: workflowId
      })
    }
  });
}